module.exports = __webpack_public_path__ + "static/img/bg2.126add9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg2.jpg
// module id = 81hm
// module chunks = 78